<template>
  <div class="pointsTableBox">
    <div class="flex flex-pack-justify pointsTab">
      <!-- 积分/AH -->
      <ul class="type_btn flex">
        <li
          @click="changeType('Points')"
          :class="type == 'Points' ? 'active' : ''"
        >
          {{ langConfig.leagues[langConfig.curLang]['POINTS'] }}
        </li>
        <li @click="changeType('AH')" :class="type == 'AH' ? 'active' : ''">
          {{ langConfig.leagues[langConfig.curLang]['AH'] }}
        </li>
      </ul>
      <div class="table-filter flex">
        <span
          :class="mobileShow == 'full' ? 'active' : ''"
          @click="filterChange('full')"
        >
        {{ langConfig.details[langConfig.curLang]['STANDING']['FULL'] }}
        </span>
        <span
          :class="mobileShow == 'form' ? 'active' : ''"
          @click="filterChange('form')"
        >
        {{ langConfig.details[langConfig.curLang]['STANDING']['FORM'] }}
        </span>
      </div>
    </div>
    <div class="data-loading" style="padding: 15% 0 20% 0" v-if="logdingFlag()">
      <van-loading vertical>{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</van-loading>
    </div>
    <div v-else>
      <!-- 主客场 -->
      <ul class="HA_btn flex" v-if="!datas[type].singleTab">
        <template v-for="item in datas[type].tabs">
          <li
            :key="item.value"
            @click="changeAHA(type, item.value)"
            :class="datas[type].tab == item.value ? 'active' : ''"
            v-if="
              datas[type].list.reduce((t, v) => t + v[item.value].length, 0)
            "
          >
            {{ item.label }}
          </li>
        </template>
      </ul>
      <div class="tableWarp">
        <table
          class="tableList"
          :class="mobileShow == 'full' ? 'full' : 'form'"
          v-for="group in datas[type].list"
          :key="group.name"
        >
          <thead>
            <tr>
              <th width="30">#</th>
              <template v-for="(item, index) in datas[type].TableHead">
                <th
                  :key="index"
                  :class="[
                    item == 'W/P/L' ? item.replace(/\//g, '') : item,
                    item == 'Team'
                      ? ''
                      : ['', 'Last Matches'].includes(item)
                      ? 'form'
                      : 'full',
                  ]"
                  v-if="1"
                >
                  {{ index == 0 && group.name ? group.name : type =='AH' ? langConfig.leagues[langConfig.curLang]['TABLE_HEAD_AH'][index] : langConfig.leagues[langConfig.curLang]['TABLE_HEAD_POINTS'][index] }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody v-if="type == 'Points'">
            <template v-for="(item, index) in group[datas[type].tab]">
              <tr :key="index" v-if="1">
                <td>
                  <div
                    class="relegation"
                    :style="
                      item.gradeId
                        ? {
                            backgroundColor: datas[type].grade.find(
                              (gradeItem) => gradeItem.id == item.gradeId
                            )['color'],
                          }
                        : {}
                    "
                  >
                    {{ index + 1 }}
                  </div>
                </td>
                <td class="">
                  {{ item.team.shortName || item.team.fullName }}
                </td>
                <td class="full">{{ item.matches }}</td>
                <td class="full">{{ item.win }}</td>
                <td class="full">{{ item.draw }}</td>
                <td class="full">{{ item.loss }}</td>
                <td class="full">{{ item.gf }}/{{ item.ga }}</td>
                <td class="full">{{ item.winDiff }}</td>
                <td class="full">{{ item.pts }}</td>
                <td class="form">
                  <div
                    class="record"
                    :class="'record_' + ['', 'w', '', 'l', '', 'd'][result]"
                    v-for="(result, index) in item.recentFiveResult"
                    :key="index"
                  >
                    <!-- {{ ["", "W", "", "L", "", "D"][result] }} -->
                    {{ langConfig.details[langConfig.curLang]['H2H']['RESULT_ARR'][result] }} 
                    <div class="popoverbox">
                      <div class="time flex">
                        {{ getGameTime(item.recentFive[index].startTime) }}
                      </div>
                      <div class="flex flex-pack-justify">
                        <div class="teamName home">
                          {{ item.recentFive[index].homeTeam.fullName }}
                        </div>
                        <div>
                          {{ item.recentFive[index].homeLive.scoreFull }}:{{
                            item.recentFive[index].awayLive.scoreFull
                          }}
                        </div>
                        <div class="teamName away">
                          {{ item.recentFive[index].awayTeam.fullName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-show="!group[datas[type].tab].length">
              <td :colspan="datas[type].TableHead.length + 1">
                <DefaultPic />
              </td>
            </tr>
          </tbody>
          <tbody v-if="type == 'AH'">
            <template v-for="(item, index) in group[datas[type].tab]">
              <tr :key="index" v-if="1">
                <td>
                  <div class="relegation">
                    {{ index + 1 }}
                  </div>
                </td>
                <td class="">
                  {{ item.team.shortName || item.team.fullName }}
                </td>
                <td class="full">{{ item.matches }}</td>
                <td class="full">{{ item.luck }}</td>
                <td class="full">{{ item.upLuck }}</td>
                <td class="Win full">{{ item.win }}</td>
                <td class="Push full">{{ item.draw }}</td>
                <td class="Loss full">{{ item.loss }}</td>
                <td class="WPL full">
                  {{ item.win }}/{{ item.draw }}/{{ item.loss }}
                </td>
                <td class="full">{{ item.winDiff }}</td>
                <td class="full">{{ (item.winRate * 100).toFixed(2) }}%</td>
                <td class="form" style="white-space: nowrap;">
                  <div
                    class="record"
                    :class="
                      'record_' +
                      ['', 'w', '', 'l', '', 'd'][
                        item.recentFiveLuck[_index].result
                      ]
                    "
                    v-for="(_item, _index) in item.recentFive"
                    :key="_index"
                  >
                    {{ langConfig.details[langConfig.curLang]['H2H']['RESULT_ARR'][item.recentFiveLuck[_index].result] }}
                    <div class="popoverbox">
                      <div class="time flex flex-pack-justify">
                        <span>{{ getGameTime(_item.startTime) }}</span>
                        <span class="odds">{{
                          item.recentFiveLuck[_index].hand
                        }}</span>
                      </div>
                      <div class="flex flex-pack-justify">
                        <div class="teamName home">
                          {{ _item.homeTeam.fullName }}
                        </div>
                        <div>
                          {{ _item.homeLive.scoreFull }}:{{
                            _item.awayLive.scoreFull
                          }}
                        </div>
                        <div class="teamName away">
                          {{ _item.awayTeam.fullName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-show="!group[datas[type].tab].length">
              <td :colspan="datas[type].TableHead.length + 1">
                <DefaultPic />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 标识 -->
      <ul class="relegationList flex" v-if="type == 'Points'">
        <li
          class="flex flex-align-center"
          v-for="item in datas['Points'].grade"
          :key="item.id"
        >
          <div class="drop" :style="{ backgroundColor: item.color }"></div>
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <!-- 赛制说明 -->
      <div
        class="descriptionBox"
        v-if="type == 'Points' && datas['Points'].leagueFormat"
      >
        <div class="title">{{ langConfig.leagues[langConfig.curLang]['COMPETITION_SYSTEM_DESCRIPTION'] }}:</div>
        <div class="content" v-html="datas['Points'].leagueFormat"></div>
      </div>
    </div>
  </div>
</template>
<script>
import DefaultPic from "@/components/defaultPic";
import { getPointsData, getAHData } from "@/api/api";
export default {
  props: ["params", "setting"],
  components: {
    DefaultPic,
  },
  data() {
    return {
      loading: true,
      league: {
        leagueId: null,
        season: "",
      },
      type: "Points",
      mobileShow: "full",
      TableHead: {
        Points: this.langConfig.leagues[this.langConfig.curLang]['TABLE_HEAD_POINTS'],
        AH: this.langConfig.leagues[this.langConfig.curLang]['TABLE_HEAD_AH'],
      },
      datas: {
        Points: {
          singleTab: false,
          tab: "all",
          tabs: [
            { label: this.langConfig.leagues[this.langConfig.curLang]['ALL'], value: "all" },
            { label: this.langConfig.leagues[this.langConfig.curLang]['HOME'], value: "home" },
            { label: this.langConfig.leagues[this.langConfig.curLang]['AWAY'], value: "away" },
          ],
          TableHead: this.langConfig.leagues['en']['TABLE_HEAD_POINTS'],
          grade: [],
          list: [
            {
              all: [],
              home: [],
              away: [],
            },
          ],
          leagueFormat: "",
        },
        AH: {
          singleTab: false,
          tab: "all",
          tabs: [
            { label: this.langConfig.leagues[this.langConfig.curLang]['ALL'], value: "all" },
            { label: this.langConfig.leagues[this.langConfig.curLang]['HOME'], value: "home" },
            { label: this.langConfig.leagues[this.langConfig.curLang]['AWAY'], value: "away" },
          ],
          TableHead: this.langConfig.leagues['en']['TABLE_HEAD_AH'],
          grade: [],
          list: [
            {
              all: [],
              home: [],
              away: [],
            },
          ],
        },
      },
    };
  },
  methods: {
    logdingFlag() {
      if (typeof window != "undefined" && this.loading) {
        return true;
      }
      return false;
    },
    async loadPointsData() {
      const { leagueId, season } = this.params;
      const response = await getPointsData({
        leagueId,
        season,
        userToken: "",
      });
      this.loading = false;
      if (response.state === 200) {
        const _data = response.data["standing"];
        // console.log("Points", JSON.parse(JSON.stringify(_data)));
        this.datas["Points"].grade = _data["grade"] || [];
        this.datas["Points"].group = _data["group"] || [];
        const group = new Array(this.datas["Points"].group.length || 1)
          .fill("")
          .map((item) => ({
            name: "",
            all: [],
            home: [],
            away: [],
          }));
        if (group.length > 1) {
          // 有分组赛
          this.datas["Points"].group.forEach((gradeItem, index) => {
            group[index].name = gradeItem.name;
            group[index].all = gradeItem["allStandings"] || [];
            group[index].home = gradeItem["homeStandings"] || [];
            group[index].away = gradeItem["awayStandings"] || [];
          });
        } else {
          group[0].all = _data.group?.[0]?.["allStandings"] || [];
          group[0].home = _data.group?.[0]?.["homeStandings"] || [];
          group[0].away = _data.group?.[0]?.["awayStandings"] || [];
        }

        this.datas["Points"].list = group;
        let allLength = 0;
        let homeLength = 0;
        let awayLength = 0;
        group.forEach((item) => {
          allLength += item.all.length;
          homeLength += item.home.length;
          awayLength += item.away.length;
        });
        this.datas["Points"].singleTab =
          (allLength && !homeLength && !awayLength) ||
          (!allLength && homeLength && !awayLength) ||
          (!allLength && !homeLength && awayLength);
        this.datas["Points"].leagueFormat = (_data["leagueFormat"] || "")
          .replace(/\\n/g, "<p></p>")
          .replace(/\\r/g, "<p></p>");
      }
    },
    async loadAHData() {
      const { leagueId, season } = this.params;
      const response = await getAHData({
        leagueId,
        season,
        userToken: "",
      });
      this.loading = false;
      if (response.state === 200) {
        const _data = response.data;
        // console.log("AH", JSON.parse(JSON.stringify(_data)));
        const _list = [
          {
            all: _data["allStandings"] || [],
            home: _data["homeStandings"] || [],
            away: _data["awayStandings"] || [],
          },
        ];
        this.datas["AH"].list = _list;
        const allLength = _list?.[0]?.["all"].length;
        const homeLength = _list?.[0]?.["home"].length;
        const awayLength = _list?.[0]?.["away"].length;

        this.datas["AH"].singleTab =
          (allLength && !homeLength && !awayLength) ||
          (!allLength && homeLength && !awayLength) ||
          (!allLength && !homeLength && awayLength);
      }
    },
    // 日期转换-时区
    getGameTime(startTime, format = "dd/MM/YYYY HH:mm") {
      var _tz = "+08:00";
      var _this = this;
      var setting = _this.common.getCookie("setting");

      if (setting != null && setting != undefined && setting) {
        setting = JSON.parse(setting);
        _tz = setting.tsz;
      }

      if(this.langConfig.curLang == 'kr'){
        format = "YYYY/MM/dd HH:mm";
      }

      var _time = this.common.dateStr(
        this.common.getDateByArray(_tz, startTime),
        format
      );

      return _time;
    },
    // 切换Points/AH
    changeType(type) {
      this.type = type;
    },
    // 切换all/home/away
    changeAHA(type, tab) {
      this.datas[type].tab = tab;
    },
    filterChange(type) {
      this.mobileShow = type;
    },
  },
  watch: {
    params: {
      deep: true,
      handler(value) {
        if (JSON.stringify(value) != JSON.stringify(this.league)) {
          if (value["leagueId"]) {
            this.league = value;
            this.loadPointsData();
            this.loadAHData();
          }
        }
      },
    },
    setting: {
      deep: true,
      handler(value) {
        console.log("setting", value);
        this.$forceUpdate();
      },
    },
  },
};
</script>
<style lang="less">
.pointsTableBox {
  background: @color_FFF;
  padding: 16px 8px 48px 8px;

  .table-filter {
    display: none;
  }
  .type_btn {
    margin-bottom: 16px;
    li:nth-child(2) {
      margin-right: 0;
    }
    li {
      line-height: 24px;
      font-size: 14px;
      font-family: @font_family_SF_Pro_Display;
      border: 1px solid @color_BFBFBF;
      color: @color_434343;
      padding: 0 16px;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 8px;
    }
    li.active {
      color: @color_FFF;
      background: @color_FF6915;
      border: 1px solid @color_FF6915;
    }
  }
  .HA_btn {
    background: @color_F5F5F5;
    padding: 8px;
    li {
      font-size: 14px;
      color: @color_434343;
      font-family: @font_family_SF_Pro_Display;
      line-height: 24px;
      padding: 0 16px;
      cursor: pointer;
    }
    li.active {
      color: @color_FF6915;
      background: @color_FFF;
      border-radius: 4px;
    }
  }
  .tableWarp {
    .tableList {
      width: 100%;
      text-align: center;
      color: @color_434343;
      font-size: 14px;
      line-height: 24px;
      font-family: @font_family_SF_Pro_Display;
      margin-bottom: 16px;
      thead {
        background: @color_F5F5F5;
        th {
          box-sizing: border-box;
          text-align: center;
          padding: 0 8px 8px;
          &.WPL {
            display: none;
          }
          &:nth-child(1) {
            width: 30px;
          }
          &:nth-child(2) {
            width: 164px;
            text-align: left;
          }
        }
      }
      tbody {
        background: @color_FFF;
        tr {
          border-bottom: 1px solid @color_F0F0F0;
          padding: 16px 0;
        }
        td {
          padding: 16px 8px;
          word-break: break-all;
          word-wrap: break-word;
          &:first-child {
            padding: 16px 0;
          }
          &.WPL {
            display: none;
          }
        }
        td:nth-child(2) {
          text-align: left;
        }
      }
    }
  }

  .relegation {
    width: 30px;
    border-radius: 4px;
    text-align: center;
    margin: 0 8px;
  }
  .record {
    position: relative;
    display: inline-block;
    color: @color_FFF;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    margin: 0 2px;
    vertical-align: top;
    cursor: pointer;
    .popoverbox {
      display: none;
    }
    &:hover {
      .popoverbox {
        display: block;
      }
    }
    &.record_w {
      background: @color_4BCC87;
    }
    &.record_d {
      background: @color_52B1FF;
    }
    &.record_l {
      background: @color_E8503A;
    }
  }

  .popoverbox {
    position: absolute;
    right: -20px;
    bottom: -66px;
    width: 343px;
    height: 60px;
    padding: 8px;
    border-radius: 4px;
    opacity: 0.7;
    background: @color_000;
    font-family: @font_family_SF_Pro_Display;
    color: @color_FFF;
    z-index: 99;
    text-align: left;
    line-height: 22px;
    .time {
      font-size: 12px;
    }
    .odds {
      font-size: 12px;
      color: #ffb23f;
      display: block;
    }
    .teamName {
      font-size: 14px;
      width: 135px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.away {
        text-align: right;
      }
    }
  }
  .popoverbox::after {
    position: absolute;
    right: 27px;
    display: inline-block;
    content: "";
    top: -10px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top: 5px solid @color_000;
    opacity: 0.8;
    transform: rotate(180deg);
  }
  .relegationList {
    li {
      padding: 16px 8px;
      .name {
        color: @color_8C8C8C;
        font-family: @font_family_SF_Pro_Display;
        font-size: 12px;
      }
      .drop {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        // background: @color_4BCC87;
        margin-right: 4px;
      }
    }
  }
  .descriptionBox {
    width: 100%;
    background: @color_F5F5F5;
    padding: 16px;
    .title {
      font-size: 16px;
      font-family: @font_family_SF_Pro_Display;
      color: @color_434343;
      margin-bottom: 10px;
    }
    .content {
      padding: 0 !important;
      font-family: @font_family_SF_Pro_Display;
      font-size: 14px;
      line-height: 22px;
      color: @color_8C8C8C;
      word-break: break-all;
      strong {
        display: block;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .pointsTableBox {
    padding: 0.12rem 0.12rem 0.24rem 0.12rem;
    .tableWarp {
      width: 100%;
      .tableList {
        &.full {
          .form {
            display: none;
          }
          .Win,
          .Push,
          .Loss {
            display: none;
          }
        }
        &.form {
          .full {
            display: none;
          }
          tbody {
            td {
              &:nth-child(2) {
                width: 1.18rem;
              }
            }
          }
        }
        font-size: 0.14rem;
        line-height: 0.24rem;
        margin-bottom: 0.12rem;
        thead {
          th {
            padding: 0.08rem 0;
            font-size: 0.12rem;
            line-height: 0.14rem;
            &.WPL {
              display: table-cell;
            }
            &:nth-child(1) {
              width: 0.2rem;
            }
            &:nth-child(2) {
              width: 0.7rem;
            }
          }
        }
        tbody {
          tr {
            padding: 0.16rem 0;
          }
          td {
            padding: 0.16rem 0;
            font-size: 0.13rem;
            line-height: 0.15rem;
            &:first-child {
              padding: 0.16rem 0;
            }
            &:nth-child(2) {
              font-size: 0.14rem;
              // width: 1.18rem;
            }
            &.WPL {
              display: table-cell;
            }
          }
        }
      }
    }

    .pointsTab {
      width: 100%;
    }

    .table-filter {
      width: 0.84rem;
      height: 0.2rem;
      display: flex;
      align-items: center;
      border: 1px solid #bfbfbf;
      background-color: #f5f5f5;
      font-size: 0.12rem;
      box-sizing: border-box;
      border-radius: 0.04rem;
      position: relative;
      overflow: hidden;
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        background-color: #bfbfbf;
        left: 50%;
        top: 0;
        transform: translate(-50%);
      }
      span {
        flex: 1;
        text-align: center;
        line-height: 0.18rem;
        &.active {
          background-color: #fff;
          color: @color_FF6915;
        }
      }
    }
    .HA_btn {
      width: 100%;
      padding: 0.08rem;
      li {
        font-size: 0.14rem;
        line-height: 0.24rem;
        padding: 0 0.16rem;
        &.active {
          border-radius: 0.04rem;
        }
      }
    }
    .type_btn {
      margin-bottom: 0.12rem;
      li {
        height: 0.24rem;
        line-height: 0.24rem;
        font-size: 0.14rem;
        padding: 0 0.16rem;
        border-radius: 0.04rem;
        cursor: pointer;
        margin-right: 0.08rem;
      }
    }
    .record {
      width: 0.24rem;
      height: 0.24rem;
      line-height: 0.24rem;
      border-radius: 50%;
      margin: 0 0.02rem;
      &:hover {
        .popoverbox {
          display: none;
        }
      }
    }
    .relegation {
      width: 0.2rem;
      border-radius: 0.04rem;
      margin: 0 0.08rem;
    }
    .relegationList {
      li {
        padding: 16px 8px;
        .name {
          font-size: 0.12rem;
        }
        .drop {
          width: 0.16rem;
          height: 0.16rem;
          margin-right: 0.04rem;
        }
      }
    }
    .descriptionBox {
      width: 100%;
      padding: 0.16rem;
      .title {
        font-size: 0.16rem;
        margin-bottom: 0.1rem;
      }
      .content {
        font-size: 0.14rem;
        line-height: 0.22rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/leagues/components/pointsTable.vue